// Faz 5 — Blog listesi/detay + Projeler sayfası arayüz metinleri (TR/EN).
// Blog yazıları ve projelerin veritabanından gelen içerikleri (başlık, özet, kategori, sektör)
// admin panelinde girildiği dilde kalır; burada yalnızca arayüz metinleri çevrilir.

export const BLOG_I18N = {
  tr: {
    seoTitle: null, // TR'de settings.pages.blog üzerinden gelir
    seoDesc: null,
    eyebrow: "İçgörüler",
    title: "Dijital Dönüşüm Blogu",
    subtitle: "Kurumsal web, B2B, CRM ve AI üretimi üzerine düşünceler.",
    all: "Tümü",
    readMin: (n) => `${n} dk`,
    readMore: "Devamını oku",
    empty: "Bu kategori için içerik henüz eklenmedi.",
  },
  en: {
    seoTitle: "Digital Transformation Blog | Dijital Roket",
    seoDesc:
      "Insights on enterprise web, B2B systems, CRM, custom software and AI-native production from the Dijital Roket team.",
    eyebrow: "Insights",
    title: "Digital Transformation Blog",
    subtitle: "Thoughts on enterprise web, B2B, CRM and AI-native production.",
    all: "All",
    readMin: (n) => `${n} min`,
    readMore: "Read more",
    empty: "No content has been added for this category yet.",
  },
};

export const BLOG_DETAIL_I18N = {
  tr: {
    notFound: "Yazı bulunamadı",
    backToBlog: "Bloga dön",
    loading: "Yükleniyor...",
    allPosts: "Tüm Yazılar",
    breadcrumbHome: "Ana Sayfa",
    updated: "Güncelleme:",
    readTime: (n) => `${n} dk okuma`,
    firstPartyTitle: "Dijital Roket Deneyimi",
    firstPartyNote: "Bu bölüm, Dijital Roket'in gerçek proje ve uzmanlık deneyimine dayanır.",
    expertInsight: "Uzman Görüşü",
    projectExample: "Gerçek Proje Örneği",
    methodology: "Yöntem",
    faqEyebrow: "Sık Sorulan Sorular",
    faqTitle: "Bu konuda merak edilenler",
    authorLabel: "Yazar",
    relatedServices: "İlgili hizmetlerimiz",
    serviceChip: (label) => `${label} çözümlerimizi inceleyin`,
    relatedProjectsEyebrow: "İlgili Projeler",
    relatedProjectsTitle: "Bu konuyla ilgili işlerimiz",
    relatedPosts: "İlgili yazılar",
    read: "Oku",
    sourcesTitle: "Kaynaklar",
    locale: "tr-TR",
    inLanguage: "tr-TR",
  },
  en: {
    notFound: "Article not found",
    backToBlog: "Back to blog",
    loading: "Loading...",
    allPosts: "All Articles",
    breadcrumbHome: "Home",
    updated: "Updated:",
    readTime: (n) => `${n} min read`,
    firstPartyTitle: "The Dijital Roket Experience",
    firstPartyNote: "This section is based on Dijital Roket's real project and domain experience.",
    expertInsight: "Expert Insight",
    projectExample: "Real Project Example",
    methodology: "Methodology",
    faqEyebrow: "Frequently Asked Questions",
    faqTitle: "Common questions on this topic",
    authorLabel: "Author",
    relatedServices: "Related services",
    serviceChip: (label) => `Explore our ${label} solutions`,
    relatedProjectsEyebrow: "Related Projects",
    relatedProjectsTitle: "Our work on this topic",
    relatedPosts: "Related articles",
    read: "Read",
    sourcesTitle: "Sources",
    locale: "en-GB",
    inLanguage: "en",
  },
};

export const PROJECTS_I18N = {
  tr: {
    seoTitle: "Dijital Roket Projeleri | Web, Yazılım, B2B & AI",
    seoDesc:
      "Dijital Roket tarafından geliştirilen kurumsal web sitelerini, B2B sistemlerini, özel yazılım projelerini, yönetim panellerini ve dijital dönüşüm çalışmalarını inceleyin.",
    eyebrow: "DR AI Çalışmaları",
    title: "Dijital Roket Projeleri",
    subtitle: "Fikirleri sadece tasarıma değil, çalışan dijital sistemlere dönüştürüyoruz.",
    all: "Tümü",
    duration: (n) => `${n} günde geliştirildi`,
    explore: "Projeyi incele",
    empty: "Bu kategori için içerik henüz eklenmedi.",
    badges: {},
  },
  en: {
    seoTitle: "Dijital Roket Case Studies | Web, Software, B2B & AI",
    seoDesc:
      "Explore the corporate websites, B2B systems, custom software projects, admin panels and digital transformation work built by Dijital Roket.",
    eyebrow: "DR AI Work",
    title: "Dijital Roket Case Studies",
    subtitle: "We turn ideas into working digital systems, not just designs.",
    all: "All",
    duration: (n) => `Built in ${n} days`,
    explore: "View the project",
    empty: "No content has been added for this category yet.",
    badges: { "GERÇEK PROJE": "REAL PROJECT", "ÇÖZÜM MİMARİSİ": "SOLUTION ARCHITECTURE" },
  },
};
